const absoluteUrlPattern = /^[a-z][a-z\d+\-.]*:\/\//i;

const ensureProtocol = (url: string, protocol: string) => {
    if (!url || absoluteUrlPattern.test(url)) {
        return url;
    }

    return `${protocol}//${url}`;
}

export const getBaseURL = () => {
    const url = import.meta.env.VITE_BASE_URL;

    if (import.meta.env.MODE === "production") {
        return ensureProtocol(url, "https:");
    }

    return url;
}

export const getFrontendUrl = () => {
    const tenant = window.location.pathname.split('/')[1];

    return `${getBaseFrontendUrl()}/${tenant}`;
}

export const getBaseFrontendUrl = () => {
    const url = import.meta.env.VITE_FRONTEND_URL;

    if (import.meta.env.MODE === "production") {
        return ensureProtocol(url, "https:");
    }

    return url;
}
